export class ServerData {
  public Key: string;
  public Name: string;
  public Instance: string;
  public ConnectionString: string;
  public IsSelected: boolean;
}


